import { ChainId } from '@cronos-app/sdk';
import { getZkcroPerToken } from '@ui/hooks/exchangeRate/useZkcroPerToken';
import { Token } from '@ui/models/token/model';
import { Fraction } from 'bi-fraction';

import type { TokenFetcher } from '../model';
import { cdcFetcher } from './cdc';

export const zkcroFetcher: TokenFetcher<Token.zkCRO> = {
  support: (token): token is Token.zkCRO => token === Token.zkCRO,
  fetch: async (_, layer, desiredNetwork = ChainId.ETHEREUM) => {
    const rate = await getZkcroPerToken(desiredNetwork, Token.CRO);
    const res = await cdcFetcher.fetch(Token.CRO, layer, desiredNetwork);
    return {
      usd_price: new Fraction(res.usd_price).div(rate),
      usd_price_change_24h: res.usd_price_change_24h,
    };
  },
};
